import React from 'react'
import { useFormContext } from '@/state/main-form/reducer'
import { ChatBar } from './chat-bar'
import style from './index.module.sass'
import { Messages } from './messages'
import { TopBar } from './top-bar'
import { useLlm } from './useLlm'

type Props = {
	setChatOpen: (chatOpen: boolean) => void
}

export const ChatInterface = ({ setChatOpen }: Props) => {
	const { send, messages, awaitingResponse } = useLlm()
	const formContext = useFormContext()
	return (
		<>
			<TopBar setChatOpen={setChatOpen} />
			<div className={style.container}>
				<Messages messages={messages} />

				<ChatBar awaitingResponse={awaitingResponse} send={send} hasMessages={messages.length > 0} />
			</div>
		</>
	)
}
